var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 pt-4"},[_c('b-container',{attrs:{"fluid":"xl"}},[_c('div',{staticClass:"mb-3"},[_c('div',{staticClass:"h3 mb-0"},[_vm._v(" Настройки ")])]),_c('div',{staticClass:"mt-2"},[_c('router-link',{attrs:{"to":"/banner-management"}},[_vm._v(" Управление баннерами ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }